import axios from 'axios'
const couchDB = axios.create({
  baseURL: 'https://c4fitness.lk:4984',
  auth: {
    username: 'admin',
    password: 'c4@123',
  },
})

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  async doPayment({ commit, state }, { paymentDetails }) {
    debugger
    const response = await couchDB.post('/c4_db', paymentDetails)
    return response.data
  },
  async getPaymentForcurrentDate({ commit, state }, query) {
    const response = await couchDB.post('/c4_db/_find', query)
    return response.data
  },
  async sendEmailToClient({ commit, state }, { emailDetails }) {
    axios
      .post('http://localhost:3000/sendMail', emailDetails)
      .then(function(response) {
        console.log(response)
      })
      .catch(function(error) {
        console.log(error)
      })
  },
}
